import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { Check, type LucideIcon } from "lucide-react";

type StatusBadgeIconType = LucideIcon | "checked";

interface StatusBadgeProps {
  icon: StatusBadgeIconType;
  iconColor?: string;
  textColor?: string;
  containerColor?: string;
  children: React.ReactNode;
}

export function StatusBadge({
  icon,
  iconColor = "text-gray-700",
  textColor = "text-foreground",
  containerColor = "bg-gray-100 border border-gray-200",
  children,
}: StatusBadgeProps) {
  const Icon = icon === "checked" ? null : (icon as LucideIcon);

  const basePillClasses =
    "gap-1.5 px-2 inline-flex flex-row items-center justify-start overflow-hidden whitespace-nowrap text-ellipsis text-xs font-semibold py-0.5 rounded-md";

  return (
    <Badge
      variant="outline"
      className={cn(basePillClasses, containerColor, textColor)}
    >
      {icon === "checked" ? (
        <div className="w-3 h-3 rounded-full flex items-center justify-center bg-green-500">
          <Check className="h-2 w-2 text-white" />
        </div>
      ) : (
        Icon && (
          <Icon className={cn("h-3.5 w-3.5", iconColor)} aria-hidden="true" />
        )
      )}
      {children}
    </Badge>
  );
}
